import { z } from 'zod'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

import { ExtraInitializationParams } from '../../../cross-chain-deployment/ExtraInitializationParams'

export const ExtraInitializationParamsSchema = z.string()

type ExtraInitializationParamsReportText = z.infer<
  typeof ExtraInitializationParamsSchema
>

export function mapDomainToReportText(
  postDeploymentModule: ExtraInitializationParams
): ExtraInitializationParamsReportText {
  return postDeploymentModule.getValue().getValue()
}

export function mapReportTextToDomain(
  reportText: ExtraInitializationParamsReportText
): ExtraInitializationParams {
  return ExtraInitializationParams.create({
    extraInitializationParamsValue: HexNumber.create({
      hexNumberValue: reportText,
    }),
  })
}
